import axios from 'axios';

const baseURL = 'https://api.nivis.bravosul.app/api';

const api = axios.create({
  baseURL,
});

export default api;
